function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("g", {
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M54 24.5c0 3.555-9.015 1.212-15.581 3.112-4.144 1.199-7.06 7.54-12.509 7.54C11.827 35.152 3 30.3 3 24.5S14.417 14 28.5 14 54 18.701 54 24.5z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54 25v7.5c0 3.555-9.015 1.212-15.581 3.112-4.144 1.198-7.06 7.54-12.509 7.54C11.827 43.152 3 38.3 3 32.5V25"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 22.049,
  cy: 27.7,
  rx: 6.5,
  ry: 3
})), /*#__PURE__*/React.createElement("path", {
  d: "M6 24l22-8M25 23l15-6M33 27l16-7M19 16l31 7M12 19l28 6"
}));

var SvgSteak = function SvgSteak(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSteak, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Steak.ab9a5b7a.svg";
export { ForwardRef as ReactComponent };